export enum AdaptiveType {
    Unknown = 'unknown',
    LessThan768 = 'less768',
    MoreThan768 = 'more768',
    MoreThan960 = 'more960',
    MoreThan1024 = 'more1024'
}

export enum SearchFormAdaptiveType {
    Unknown = 'unknown',
    LessThan768 = 'less768',
    MoreThan768 = 'more768'
}

export enum PostFiltersAdaptiveType {
    Unknown = 'unknown',
    LessThan768 = 'less768',
    MoreThan768 = 'more768'
}

export enum ReviewsAdaptiveType {
    Unknown = 'unknown',
    LessThan512 = 'less512',
    MoreThan512 = 'more512',
    MoreThan620 = 'more620',
    MoreThan768 = 'more768',
    MoreThan984 = 'more984',
}

export enum HotelRoomsAdaptiveType {
    Unknown = 'unknown',
    MoreThan1232 = 'more1232',
    LessThan768 = 'less768',
    Tablet768_960 = 'tablet'
}
